import { render, staticRenderFns } from "./BuyCars.vue?vue&type=template&id=05a409ab&"
import script from "./BuyCars.vue?vue&type=script&lang=js&"
export * from "./BuyCars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports